import { useEffect, useRef, useState } from "react";
import { Loader2, Search } from "lucide-react";

export const Suggest = ({ value, onChange, fetcher, onPick, render, testid, minChars = 3, hint, inputClass = "qr-input", ...inputProps }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const typed = useRef(false);
  useEffect(() => {
    if (!typed.current || (value || "").trim().length < minChars) { setItems([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try { const r = await fetcher(value.trim()); setItems(r); setOpen(true); } catch { setItems([]); } finally { setLoading(false); }
    }, 350);
    return () => clearTimeout(t);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative">
      <input {...inputProps} data-testid={testid} className={`${inputClass} pr-10`} value={value} autoComplete="off"
             onChange={(e) => { typed.current = true; onChange(e.target.value); }} onFocus={() => items.length && setOpen(true)}
             onBlur={(e) => { setTimeout(() => setOpen(false), 180); inputProps.onBlur?.(e); }} />
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}</span>
      {open && items.length > 0 && (
        <ul data-testid={`${testid}-suggestions`} className="absolute z-30 left-0 right-0 mt-1 bg-white border border-slate-200 rounded-md shadow-xl max-h-72 overflow-auto">
          {items.map((it, i) => (
            <li key={i}>
              <button type="button" data-testid={`${testid}-suggestion-${i}`} onMouseDown={(e) => e.preventDefault()}
                      onClick={() => { typed.current = false; onPick(it); setOpen(false); setItems([]); }}
                      className="w-full text-left px-4 py-2.5 text-sm hover:bg-slate-50 border-b border-slate-100 last:border-0">{render(it)}</button>
            </li>
          ))}
        </ul>
      )}
      {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
    </div>
  );
};
